/* =========================
   THEME.JS (FULL)
========================= */

/* BUY NOW BUTTON */
function initBuyNowButtons() {
  document.querySelectorAll(".buy-now-btn").forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(() => {
          window.location.href = "/checkout";
        })
        .catch((error) => {
          console.error("Buy Now error:", error);
        });
    });
  });
}

/* Quantity buttons (PRODUCT PAGE) */
function initProductQuantityButtons() {
  const decreaseBtn = document.querySelector(".quantity-btn.decrease");
  const increaseBtn = document.querySelector(".quantity-btn.increase");
  const quantityInput = document.querySelector("input[name='quantity']");

  if (!decreaseBtn || !increaseBtn || !quantityInput) return;

  decreaseBtn.addEventListener("click", () => {
    const qty = parseInt(quantityInput.value || "1", 10);
    if (qty > 1) quantityInput.value = qty - 1;
  });

  increaseBtn.addEventListener("click", () => {
    const qty = parseInt(quantityInput.value || "1", 10);
    quantityInput.value = qty + 1;
  });
}

/* Cart Header Counter */
function updateCartCounter() {
  const cartCounter = document.getElementById("cart-counter");
  if (!cartCounter) return;

  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      cartCounter.textContent = cart.item_count;
    })
    .catch(() => {});
}

function initCartCounter() {
  updateCartCounter();
}

/* CART DRAWER */
function bindAddToCartForms() {
  const cartDrawer = document.getElementById("cart-drawer");
  if (!cartDrawer) return;

  const drawerOverlay = cartDrawer.querySelector(".cart-drawer__overlay");
  const drawerCloseBtn = cartDrawer.querySelector(".cart-drawer__close");
  const drawerItemWrapper = cartDrawer.querySelector(".cart-drawer__item");
  const drawerViewCart = cartDrawer.querySelector(".drawer-view-cart");

  function openDrawer() {
    cartDrawer.classList.add("cart-drawer--open");
  }
  function closeDrawer() {
    cartDrawer.classList.remove("cart-drawer--open");
  }

  drawerCloseBtn?.addEventListener("click", closeDrawer);
  drawerOverlay?.addEventListener("click", closeDrawer);

  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("form");
    if (!form) return;

    const action = form.getAttribute("action") || "";
    if (!/\/cart\/add/.test(action)) return;

    e.preventDefault();

    const formData = new FormData(form);
    if (formData.get("return_to")) formData.delete("return_to");
    if (!formData.get("quantity")) formData.set("quantity", "1");

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        credentials: "same-origin",
      });

      const item = await res.json();
      updateCartDrawer(item);
      updateCartCounter();
      openDrawer();
    } catch (err) {
      console.error("Add to cart error", err);
    }
  });

  function updateCartDrawer(item) {
    if (!drawerItemWrapper) return;

    const img = drawerItemWrapper.querySelector("img");
    const name = drawerItemWrapper.querySelector("p");

    // IMPORTANT:
    // In cart-drawer.liquid set:
    // <img id="drawer-product-img" src="" alt="" data-placeholder="{{ 'placeholder-product.jpg' | asset_url }}">
    const placeholder = img?.dataset?.placeholder || "";

    const imgUrl =
      item?.image ||
      item?.featured_image?.url ||
      (item?.featured_image && typeof item.featured_image === "object"
        ? item.featured_image.src
        : null);

    if (img) {
      img.src = imgUrl || placeholder;
      img.alt = item?.product_title || item?.title || "Product image";

      img.onerror = () => {
        img.onerror = null;
        img.src = placeholder;
      };
    }

    if (name) {
      const productTitle = item?.product_title || item?.title || "";
      name.textContent = item?.variant_title
        ? `${productTitle} (${item.variant_title})`
        : productTitle;
    }

    if (drawerViewCart) {
      fetch("/cart.js", { credentials: "same-origin" })
        .then((res) => res.json())
        .then((cart) => {
          drawerViewCart.innerHTML = `View cart (${cart.item_count})`;
        })
        .catch(() => {});
    }
  }
}

/* DYNAMIC MIN HEIGHTS FOR CARDS */
function dynamicMinHeight(targetSelector, cssVarName) {
  document.documentElement.style.setProperty(cssVarName, "auto");

  const elements = Array.from(document.querySelectorAll(targetSelector));
  if (!elements.length) return;

  const heights = elements.map((el) => el.offsetHeight);
  const maxHeight = Math.max.apply(null, heights);

  document.documentElement.style.setProperty(cssVarName, maxHeight + "px");
}

function initDynamicHeights() {
  dynamicMinHeight(".featured-products .product-card", "--featuredCardHeight");
  dynamicMinHeight(
    ".testimonial-section .testimonial-card",
    "--testimonialCardHeight",
  );
}

/* FILTER: Show more / Show less (Categories + Brand) - NO LAG VERSION */
function initFilterShowMore() {
  const LIMITS = { categories: 10, brand: 10 };

  function applyCard(cardEl) {
    const key = cardEl.getAttribute("data-filter-group");
    const limit = LIMITS[key];
    if (!limit) return;

    const listEl = cardEl.querySelector(".js-filter-list");
    if (!listEl) return;

    const items = Array.from(listEl.querySelectorAll(".filter-option"));

    // remove button if not needed
    if (items.length <= limit) {
      items.forEach((el) => el.classList.remove("filter-item--hidden"));
      cardEl.classList.remove("is-expanded");
      const oldBtn = listEl.querySelector(".filter-showmore-btn");
      if (oldBtn) oldBtn.remove();
      return;
    }

    // ensure button exists once
    let btn = listEl.querySelector(".filter-showmore-btn");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "filter-showmore-btn";
      btn.setAttribute("aria-expanded", "false");
      listEl.appendChild(btn);

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        cardEl.classList.toggle("is-expanded");
        applyCard(cardEl);
      });
    }

    const expanded = cardEl.classList.contains("is-expanded");
    btn.textContent = expanded ? "Show less" : "Show more";
    btn.setAttribute("aria-expanded", expanded ? "true" : "false");

    items.forEach((itemEl, idx) => {
      const checked = !!itemEl.querySelector('input[type="checkbox"]:checked');
      if (expanded || idx < limit || checked) {
        itemEl.classList.remove("filter-item--hidden");
      } else {
        itemEl.classList.add("filter-item--hidden");
      }
    });
  }

  function applyAll(root) {
    root
      .querySelectorAll(
        '.filter-card[data-filter-group="categories"], .filter-card[data-filter-group="brand"]',
      )
      .forEach(applyCard);
  }

  const drawer = document.getElementById("filter-drawer") || document;
  applyAll(drawer);

  // only re-apply the card user interacted with (fast)
  drawer.addEventListener("change", (e) => {
    if (!e.target.matches('input[type="checkbox"]')) return;
    const card = e.target.closest(".filter-card");
    if (!card) return;
    applyCard(card);
  });

  // if mobile drawer opens, apply once (in case DOM changed)
  const openBtn = document.getElementById("open-filter-drawer");
  openBtn?.addEventListener("click", () => applyAll(drawer));
}

/* INIT */
document.addEventListener("DOMContentLoaded", function () {
  initBuyNowButtons();
  initProductQuantityButtons();
  initCartCounter();
  bindAddToCartForms();
  initFilterShowMore();
});

window.addEventListener("load", initDynamicHeights);
window.addEventListener("resize", initDynamicHeights);

// Owl carousel hooks (only if jQuery + owl exists)
if (window.jQuery) {
  jQuery(document).on(
    "initialized.owl.carousel translated.owl.carousel resized.owl.carousel",
    ".featured-products__carousel, .testimonial-section__carousel",
    function () {
      initDynamicHeights();
    },
  );
}
